import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-mobile-datepicker';
import './style.css';

const MONTH_MAP = {
  '1': 'Jan',
  '2': 'Feb',
  '3': 'Mar',
  '4': 'Apr',
  '5': 'May',
  '6': 'Jun',
  '7': 'Jul',
  '8': 'Aug',
  '9': 'Sep',
  '10': 'Oct',
  '11': 'Nov',
  '12': 'Dec',
};

const DATA_CONFIG = {
  'month': {
      format: value => MONTH_MAP[value.getMonth() + 1],
      caption: 'Mon',
      step: 1,
  },
  'date': {
      format: 'DD',
      caption: 'Day',
      step: 1,
  },
  'year': {
    format: 'YYYY',
    caption: 'Year',
    step: 1,
  },
};

class ScrollableDatePicker extends Component {

  state = {
    isOpen: false,
  }

  componentDidMount() {
    if (this.props.color) {
      this.setColor(this.props.color);
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    return nextProps.isOpen !== prevState.isOpen
      ? { isOpen: nextProps.isOpen }
      : {};
  }

  setColor(hexColorCode) {
    const $style = document.createElement("style");

    document.head.appendChild($style);
    $style.innerHTML = `
      .datepicker.default .datepicker-wheel {
        border-top: 1px solid ${hexColorCode};
        border-bottom: 1px solid ${hexColorCode};
      }
      .datepicker.default .datepicker-header {
        color: ${hexColorCode};
      }
      .datepicker.default .datepicker-navbar-btn {
        color: ${hexColorCode};
      }
    `;
  }

  renderPicker({ onCancel, onSelect, max, min } = this.props) {
    return (
      <DatePicker
        showCaption
        showHeader
        headerFormat="MM/DD/YYYY"
        dateConfig={DATA_CONFIG}
        isOpen={this.state.isOpen}
        onSelect={onSelect}
        confirmText="SET"
        cancelText="CANCEL"
        onCancel={onCancel}
        max={max}
        min={min}
      />
    );
  }

  render() {
    return this.renderPicker();
  }
}
ScrollableDatePicker.defaultProps = {
  hexColorCode: undefined,
};

ScrollableDatePicker.propTypes = {
  hexColorCode: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default ScrollableDatePicker;



// WEBPACK FOOTER //
// ./src/components/ScrollableDatePicker/ScrollableDatePicker.jsx